import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ActionCardIconComponent } from '../cards/action-card/action-card-icon.component';

@Component({
  selector: 'ui-card-top-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ActionCardIconComponent],
  template: `
    <div class="flex justify-start items-center" [class.gap-x-4]="icon()">
      <div class="flex flex-col gap-y-1">
        <span class="font-medium text-lg leading-none">
          {{ title() }}
        </span>
        <span class="text-xs text-neutral-7 leading-none">
          {{ subtitle() }}
        </span>
      </div>
      @if (icon()) {
        <ui-action-card-icon icon class="{{ iconClass() }}" [icon]="icon()" />
      }
    </div>
  `,
})
export class CardTopHeader {
  title = input<string>();
  subtitle = input<string>();
  icon = input<string>();
  iconClass = input<string>('text-purple bg-purple-light shadow-custom-purple');
}
